export default {
  name: 'cookies',

  data () {
    return {
      cookiesAcceptedLocal: false
    }
  },

  computed: {
    cookiesAccepted () {
      return this.$store.getters.cookiesAccepted
    },

    langISO () {
      let currLang = this.$store.getters.getCurrLanguage
      if (currLang && currLang.iso) {
        return currLang.iso
      }
      return 'en'
    }
  },
  methods: {
    acceptCookies () {
      // We'll add the animation class, and then set the store value when the animation has finished.
      this.cookiesAcceptedLocal = true

      let self = this
      setTimeout(function () {
        self.$store.dispatch('setCookiesAccepted', true)
      }, 200)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cookies/script.js